module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topBar u-wa u-fright"
  }, [_c('div', {
    staticClass: "topBar--item_right"
  }, [_c('router-link', {
    staticClass: "btn btn_blue",
    attrs: {
      "to": "/featured/add"
    }
  }, [_vm._v("\n              Add new featured video\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table--row table--row_header"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('videoDetails.title'),
    staticStyle: {
      "max-width": "190px"
    },
    on: {
      "click": function($event) {
        _vm.sort('videoDetails.title')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Title\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('videoDetails.duration'),
    staticStyle: {
      "max-width": "120px"
    },
    on: {
      "click": function($event) {
        _vm.sort('videoDetails.duration')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Duration\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('videoDetails.link'),
    staticStyle: {
      "max-width": "449px"
    },
    on: {
      "click": function($event) {
        _vm.sort('videoDetails.link')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Link\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('partner.name'),
    staticStyle: {
      "max-width": "224px"
    },
    on: {
      "click": function($event) {
        _vm.sort('partner.name')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Partner\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    staticStyle: {
      "max-width": "96px"
    }
  })]), _vm._v(" "), _vm._l((_vm.featured), function(item) {
    return _c('div', {
      staticClass: "table--row"
    }, [_c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "141px"
      }
    }, [_c('a', {
      staticClass: "table--video",
      style: ({
        'background-image': 'url(' + item.videoDetails.thumbnailUrl + ')'
      }),
      attrs: {
        "href": item.videoDetails.link,
        "target": "_blank"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "190px"
      }
    }, [_c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('strong', [_vm._v("\n                    " + _vm._s(item.videoDetails.title) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "120px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(_vm._f("duration")(item.videoDetails.duration)) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "449px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(item.videoDetails.link) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "224px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(item.partner.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "96px"
      }
    }, [_c('router-link', {
      staticClass: "btn btn btn_blueLight",
      attrs: {
        "to": {
          name: 'EditFeatured',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                  Edit\n                ")])], 1)])
  })], 2), _vm._v(" "), (_vm.nextPage) ? _c('a', {
    staticClass: "btn btn_green u-fleft",
    on: {
      "click": function($event) {
        _vm.fetchResource()
      }
    }
  }, [_vm._v("\n        Load more\n    ")]) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row u-wa"
  }, [_c('h1', [_vm._v("\n            Featured Videos\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table--col",
    staticStyle: {
      "max-width": "141px"
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Video\n                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-90fac84c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90fac84c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Featured/Featured.vue
// module id = 454
// module chunks = 1